import { type IAdminTransaction } from "@gen/app-query";

import { BannerAlert } from "~/components/banner_alert";

import {
  PaymentReviewApproveAction,
  PaymentReviewRejectAction,
} from "./actions";

interface PaymentReviewSectionProps {
  transactionId: IAdminTransaction["id"];
  isDepositInReview?: IAdminTransaction["deposit_in_review"];
  isRemainderInReview?: IAdminTransaction["remainder_in_review"];
  isPaymentInReview?: IAdminTransaction["payment_in_review"];
}

export function PaymentReviewSection({
  transactionId,
  isDepositInReview,
  isRemainderInReview,
  isPaymentInReview,
}: PaymentReviewSectionProps) {
  if (!isDepositInReview && !isRemainderInReview && !isPaymentInReview) {
    return null;
  }

  return (
    <BannerAlert
      title="Under Review"
      message="This payment is currently undergoing a manual security review. Do not fulfill the order until it has been approved. If rejected, the payment will be reverted and fully refunded."
    >
      <PaymentReviewApproveAction
        transactionId={transactionId}
        isDepositInReview={isDepositInReview}
        isPaymentInReview={isPaymentInReview}
        isRemainderInReview={isRemainderInReview}
      />
      <PaymentReviewRejectAction
        transactionId={transactionId}
        isDepositInReview={isDepositInReview}
        isPaymentInReview={isPaymentInReview}
        isRemainderInReview={isRemainderInReview}
      />
    </BannerAlert>
  );
}
